"use client"

import { ComponentConfig } from "@measured/puck"
import { twMerge } from "tailwind-merge"

import SectionBannerSidebar from "@/(admin)/modules/ui-builder/config/themes/tamda-media/TamdaMediaNewsLayout/components/SectionBannerSidebar"
import { buildTamdaMediaNewsLayoutBannerKey } from "@/lib/extract-batch-requests"
import { resolveBatchDataEntry, useBatchDataMap } from "@/lib/batch-data-context"
import { BannerData } from "@/types/types"
import { generateResponsiveCSS } from "../../../lib/helper"
import { useNewsSections } from "./hooks/useNewsSections"
import { useNewsSidebar } from "./hooks/useNewsSidebar"
import { useStableComponentId } from "./hooks/useStableComponentId"
import { TamdaMediaNewsLayoutProps } from "./types/config"

export const RenderConfig: ComponentConfig<TamdaMediaNewsLayoutProps> = {
  render: ({ className, styles, responsiveType, categoryIds, categoryIdsSidebar, id: componentId }) => {
    const id = useStableComponentId(componentId)
    const responsiveCSS = generateResponsiveCSS(id, styles || {}, responsiveType)
    const { sections, loading: sectionsLoading } = useNewsSections(categoryIds, id)
    const { sidebar, loading: sidebarLoading } = useNewsSidebar(categoryIdsSidebar, id)

    const batchData = useBatchDataMap()
    const bannerEntry = resolveBatchDataEntry<{ data?: BannerData[] }>(batchData, {
      key: buildTamdaMediaNewsLayoutBannerKey(id),
      prefix: "tamda-media-news-layout:",
      suffix: ":banner",
    })
    const bannerData = bannerEntry?.data?.[0]

    return (
      <>
        {responsiveCSS}
        <div className={twMerge(className)} id={id}>
          <SectionBannerSidebar
            sections={sections}
            sidebar={sidebar}
            banner={bannerData}
            isLoading={sectionsLoading || sidebarLoading}
          />
        </div>
      </>
    )
  },
}

export type { TamdaMediaNewsLayoutProps } from "./types/config"
